module.exports = __webpack_public_path__ + "img/shape2.02bc40c3.png";